import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaWhatsapp, FaFilter, FaUserCheck, FaClipboardList } from 'react-icons/fa';
import './IntegrationJourneySection.css';

const steps = [
  { key: 'lead', n: '01', Icon: FaWhatsapp },
  { key: 'converlead', n: '02', Icon: FaFilter, tone: 'comercial', tagged: true },
  { key: 'conversion', n: '03', Icon: FaUserCheck },
  { key: 'axys', n: '04', Icon: FaClipboardList, tone: 'operacao', tagged: true },
];

const IntegrationJourneySection = () => {
  const { t } = useTranslation();

  return (
    <section className="integration-journey" id="ecossistema">
      <div className="container">
        <p className="services-kicker">Como funciona</p>
        <h2 className="section-title">{t('journey.title')}</h2>
        <p className="section-subtitle">
          Cada módulo resolve um momento da operação. No ecossistema Convertrex, comercial e gestão
          deixam de viver em sistemas separados.
        </p>

        <ol className="journey-flow">
          {steps.map((step) => {
            const { Icon } = step;

            return (
              <li
                className={`journey-step${step.tone ? ` journey-step--${step.tone}` : ''}`}
                key={step.key}
              >
                <div className="journey-top">
                  <span className="journey-n">{step.n}</span>
                  <span className="journey-icon" aria-hidden="true">
                    <Icon size={18} />
                  </span>
                </div>
                {step.tagged ? (
                  <span className="journey-tag">{t(`journey.steps.${step.key}.tag`)}</span>
                ) : null}
                <h3>{t(`journey.steps.${step.key}.title`)}</h3>
                <p>{t(`journey.steps.${step.key}.description`)}</p>
              </li>
            );
          })}
        </ol>

        <p className="journey-message">{t('journey.message')}</p>
      </div>
    </section>
  );
};

export default IntegrationJourneySection;
